/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { useBooking } from "../../hooks/useBooking";
import ProviderCard from "./ProviderCard";

const SelectedProviderCard = ({ provider, canEdit, canDelete }) => {
  const { setSelectedProvider, setSelectedTime } = useBooking();

  const handleDelete = (e) => {
    e.stopPropagation();
    setSelectedProvider(null);
    setSelectedTime(null);
  };

  return <ProviderCard provider={provider} canEdit={canEdit} canDelete={canDelete} onDelete={handleDelete} />;
};

export default SelectedProviderCard;
